import { index,inventory,  show, store, update, destroy, indexitems, returnBack} from '../../../api/patientTransactionHistory';

export const actions = {

    index({commit}, params = {}) {
        return new Promise((resolve, reject) => {
            index(params).then(res => {
                commit("SET_LIST", res.data.data.pthistorys.data);
                commit("UPDATE_PAGINATION",{key: 'total', value: res.data.data.pthistorys.pagination.total});
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    inventory({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
          inventory(params)
            .then(response => {
              commit('SET_INVENTORY', response.data.data.pthistorys.data);
              resolve(response.data);
            })
            .catch(error => {
              reject(error.response.data);
            });
        });
      },    
    show({commit},id) {
        return new Promise((resolve,reject) => {
            show(id).then(res => {
                commit("SET_MODEL",res.data.data);
                resolve(res.data)
            }).catch(err => {
                console.log(err);
                reject(err.response.data)
            })
        })
    },
    
    indexitems({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
          indexitems(params)
            .then(response => {
              commit("SET_LIST",response.data.data.patientTransactions);
              resolve(response.data);
            })
            .catch(error => {
              reject(error.response.data);
            });
        });
    },

    returnBack({ commit }, id) {
    return new Promise((resolve, reject) => {
        returnBack(id)
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error.response.data);
        });
    });
    },

    store({commit},data) {
        return new Promise((resolve,reject) => {
            store(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    update({commit},data) {
        return new Promise((resolve,reject) => {
            update(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    destroy({commit},id) {
        return new Promise((resolve,reject) => {
            destroy(id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    updateSort({commit}, sort){
        commit("SET_SORT",sort)
    },

    updateFilter({commit}, filter){
        commit('SET_FILTER', JSON.parse( JSON.stringify( filter)))
    },

    updateColumn({commit}, obj){
        commit('UPDATE_COLUMN', obj)
    },

    updatePagination({commit}, pagination){
        commit('UPDATE_PAGINATION', pagination )
    },

    refreshData({commit}){
        return new Promise((resolve, reject) => {
            commit("REFRESH");
            resolve()
        })
    },
    empty({ commit }) {
        return new Promise((resolve, reject) => {
            commit("EMPTY_MODEL");
            resolve()
        })
    },


}
